import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectHasPermission } from 'app/reducers/context.selectors';
import { PermissionCode } from 'app/helpers/permission-codes';

// Permission code from HubPermissionCode enum.

/**
 * Полоса вкладок страницы меню. Сидит на пустом сегменте роута, поэтому видна на всех её
 * экранах, а URL не меняет — относительные навигации внутри menu-main продолжают работать
 * как раньше.
 */
@Component({
  selector: 'app-menu-tabs',
  templateUrl: './menu-tabs.component.html',
  styleUrls: ['./menu-tabs.component.scss'],
})
export class MenuTabsComponent {
  /** Вкладка видна при праве просмотра спец-инструкций; симметрично гарду на роуте. */
  public hasSpecialInstructionView$: Observable<boolean> = this.store.select(selectHasPermission(PermissionCode.SpecialInstructionView));

  constructor(private store: Store) {
  }
}
